<app-tools-catalogue-menu
  [breadcrumbLinks]="breadcrumbLinks"
></app-tools-catalogue-menu>

<div class="container m-t-alt">
  <div class="columns">
    <div class="column is-10 is-offset-1">
      <div class="card has-background-white mb-6">
        <form [formGroup]="form" (submit)="submit()">
          <h1 class="title is-2 mt-6">
            Submit a tool to the Catalogue of Tools & Metrics for Trustworthy AI
          </h1>
          <div class="content is-small">
            <p class="mb-5">
              The Catalogue of Tools & Metrics for Trustworthy AI is an
              interactive collection of the latest tools and resources to help
              AI actors be accountable and implement trustworthy AI systems. A
              tool is defined as an instrument, method or resource that can be
              leveraged to facilitate the implementation of the OECD AI
              Principles (e.g. toolkits to check for biases, robustness, risk
              management guidelines or educational material linked to AI
              systems). Tools can be used in different contexts and for
              different use cases. Your submission will be vetted by the OECD
              before being published on the catalogue. Thank you for your
              submission!
            </p>
          </div>
          <div class="field mb-5">
            <label class="is-size-7" for="title-input"
              >Name of the tool<span class="has-text-danger">*</span></label
            >
            <div class="control mb-0">
              <input
                class="input is-large"
                [ngClass]="{
                  'is-danger-bis': showErrors && invalidInputs.includes('title')
                }"
                type="text"
                formControlName="title"
                id="title-input"
                placeholder="Official name of the tool..."
              />
            </div>
          </div>
          <div class="field mb-5">
            <label class="is-size-7" for="excerpt-input"
              >Excerpt<span class="has-text-danger">*</span></label
            >
            <p class="is-size-8 mt-0 mb-2">
              A short description that provides an overview of the tool (maximum
              80 words).
            </p>
            <div class="control mb-4">
              <input
                class="input is-large"
                [ngClass]="{
                  'is-danger-bis':
                    showErrors && invalidInputs.includes('excerpt')
                }"
                type="text"
                placeholder="Excerpt of the tool (maximum 80 words)..."
                formControlName="excerpt"
                id="excerpt-input"
              />
            </div>
          </div>
          <div class="field mb-5">
            <label class="is-size-7"
              >Detailed description<span class="has-text-danger">*</span></label
            >
            <p class="is-size-8 mt-0 mb-2">
              Describe the background and objectives of this tool
            </p>
            <div class="control mb-4">
              <app-rich-text-input
                uniqueId="description"
                placeholder="Detailed description of the tool (maximum 500 words)..."
                (valueChanged)="onDescriptionChanged($event.value)"
                [showErrors]="
                  showErrors && invalidInputs.includes('description')
                "
                [required]="true"
                [maxWords]="500"
              ></app-rich-text-input>
            </div>
          </div>

  

          <div class="field mb-5">
            <label class="is-size-7" for="title-input">Image</label>
            <div
              class="is-flex is-flex-wrap-wrap is-align-items-flex-start is-justify-content-flex-start"
            >
              <app-image-input
                placeholder="Upload an image for this tool"
                resourceName="tools"
                (valueChanged)="onFieldChanged($event, 'image')"
                *ngIf="!form.value.defaultImage"
              ></app-image-input>

              <div
                class="has-current-file is-flex is-align-items-center is-justify-content-space-between mt-1 has-background-white-ter pl-1"
                *ngIf="form.value.defaultImage"
              >
                <img
                  width="46"
                  class="py-1 is-block"
                  [src]="
                    storagePath + form.value.defaultImage + '-thumbnail.jpg'
                  "
                />
                <span
                  class="file-cta file-remove"
                  (click)="onFieldChanged('', 'defaultImage')"
                  (keydown)="onFieldChanged('', 'defaultImage')"
                  tabindex="0"
                  ><a><i class="fa fa-times is-size-5"></i></a
                ></span>
              </div>

              <a
                (click)="showImageGalleryModal = true"
                (keydown)="showImageGalleryModal = true"
                tabindex="0"
                class="button is-ghost button--open-gallery sans has-text-link"
                *ngIf="!form.value.defaultImage && !form.value.image"
              >
                <i class="fa fa-image mr-2 mb"></i>
                <span>Or pick an image from our library</span>
              </a>
            </div>
          </div>
          <hr class="my-6" />
          <h2 class="mt-6 mb-1">Tool resources and links</h2>
          <p
            class="is-size-8 mb-5 mt-0"
            [ngClass]="{
              'has-text-danger-bis':
                showErrors && invalidInputs.includes('links')
            }"
          >
            At least one of the following fields is required: Link to the tool's
            website, Github repository of the tool, Gitlab repository, Hugging
            Face repository, Slack workspace
          </p>

          <div class="columns mb-0 is-multiline">
            <div class="column is-6 pt-5 pb-0">
              <label
                class="is-size-7"
                for="website-link-input"
                placeholder="Filter by ..."
                >Link to the tool's website</label
              >
              <div class="control">
                <input
                  class="input is-large"
                  [ngClass]="{
                    'is-danger-bis':
                      showErrors && invalidInputs.includes('links')
                  }"
                  placeholder="https://..."
                  type="url"
                  formControlName="websiteLink"
                  id="website-link-input"
                />
              </div>
            </div>
            <div class="column is-6 pt-5 pb-0">
              <label class="is-size-7" for="github-link-input"
                >Github repository of the tool</label
              >
              <div class="control">
                <input
                  class="input is-large"
                  [ngClass]="{
                    'is-danger-bis':
                      showErrors && invalidInputs.includes('links')
                  }"
                  placeholder="https://..."
                  type="url"
                  formControlName="githubLink"
                  id="github-link-input"
                />
              </div>
            </div>
            <div class="column is-4 pt-5 pb-0">
              <label class="is-size-7" for="gitlab-link-input"
                >Gitlab repository</label
              >
              <div class="control">
                <input
                  class="input is-large"
                  [ngClass]="{
                    'is-danger-bis':
                      showErrors && invalidInputs.includes('links')
                  }"
                  placeholder="https://..."
                  type="url"
                  formControlName="gitlabLink"
                  id="gitlab-link-input"
                />
              </div>
            </div>
            <div class="column is-4 pt-5 pb-0">
              <label class="is-size-7" for="huggingFace-link-input"
                >Hugging Face repository
              </label>
              <div class="control">
                <input
                  class="input is-large"
                  [ngClass]="{
                    'is-danger-bis':
                      showErrors && invalidInputs.includes('links')
                  }"
                  placeholder="https://..."
                  type="url"
                  formControlName="huggingFaceLink"
                  id="huggingFace-link-input"
                />
              </div>
            </div>
            <div class="column is-4 pt-5 pb-0">
              <label class="is-size-7" for="slack-link-input"
                >Slack workspace</label
              >
              <div class="control">
                <input
                  class="input is-large"
                  [ngClass]="{
                    'is-danger-bis':
                      showErrors && invalidInputs.includes('links')
                  }"
                  placeholder="https://..."
                  type="url"
                  formControlName="slackLink"
                  id="slack-link-input"
                />
              </div>
            </div>
            <div class="column is-6 pt-5 pb-0">
              <label class="is-size-7" for="tool-package-input"
                >Tool's package</label
              >
              <p class="is-size-8 mt-0 mb-2">
                If available, please provide a link to the tool's package page.
              </p>
              <div class="control">
                <input
                  class="input is-large"
                  [ngClass]="{
                    'is-danger-bis':
                      showErrors && invalidInputs.includes('links')
                  }"
                  type="url"
                  placeholder="https://..."
                  formControlName="toolPackage"
                  id="tool-package-input"
                />
              </div>
            </div>
            <div class="column is-6 pt-5 pb-0">
              <label class="is-size-7" for="related-post-input"
                >Related post on OECD.AI</label
              >
              <p class="is-size-8 mt-0 mb-2">
                If available, please provide a link to the tool's related post
                on OECD.AI's "AI Wonk" blog.
              </p>
              <div class="control">
                <input
                  id="related-post-input"
                  class="input is-large"
                  placeholder="https://oecd.ai/en/wonk/..."
                  [ngClass]="{
                    'is-danger-bis': isRelatedPostInvalid
                  }"
                  type="text"
                  (change)="onRelatedPostInputChange($event.target.value)"
                />
              </div>
            </div>
          </div>

          <hr class="my-6" />
          <h2 class="mb-4">Tool categorization</h2>

          <!-- Taxonomy groups. -->
          <ng-container *ngFor="let taxonomyGroup of taxonomyGroups">
            <h3 class="mt-0 mb-1 title is-6 is-sans is-uppercase is-bold">
              {{ taxonomyGroup.name }}
            </h3>
            <p class="mt-0 mb-2 is-size-6" *ngIf="taxonomyGroup.description">
              {{ taxonomyGroup.description }}
            </p>

            <div class="columns is-multiline mb-4">
              <div
                class="column is-6 pt-5 pb-0"
                *ngFor="let taxonomyInput of taxonomyGroup.taxonomies"
              >
                <label class="is-size-7" for="excerpt-input">{{
                  taxonomyInput.label
                }}</label>

                <app-multi-tags-input
                  [values]="taxonomyInput.options"
                  [addNewOptionFunction]="taxonomyInput.createFunction"
                  [placeholder]="taxonomyInput.placeholder"
                  [maxSelectedItems]="taxonomyInput.maxSelectedItems || 99"
                  (selectedValuesChanged)="
                    onTaxonomySelected($event, taxonomyInput.propName)
                  "
                  *ngIf="taxonomyInput.options"
                >
                </app-multi-tags-input>
              </div>
            </div>

            <div
              class="columns"
              *ngIf="
                taxonomyGroup.name === 'Type' &&
                form.value.approachIds.includes(this.educationalApproachId)
              "
            >
              <div class="column">
                <label class="is-size-7 help my-1" for="duration">Duration of the tool</label>

                <div class="control">
                  <div class="select is-large is-size-7">
                    <select formControlName="duration" id="duration">
                      <option disabled [ngValue]="null">
                        If this is an educational tool with a specific duration
                        (e.g. courses, trainings), how long does it last?
                      </option>
                      <option
                        *ngFor="let item of Duration | keyvalue"
                        [value]="item.value"
                      >
                        {{ item.value }}
                      </option>
                      <option [value]="">Not applicable</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>

            <hr class="my-6" />
          </ng-container>

          <!-- Submitter information -->
          <div class="columns">
            <div class="column is-6 pt-5 pb-0">
              <h3 class="mt-0 mb-1 title is-6 is-sans is-uppercase is-bold">
                Email<span class="has-text-danger">*</span>
              </h3>

              <div class="field mb-5">
                <label class="is-size-7 help my-1" for="email-input">
                  We will use this to contact you if we have any further
                  questions related to your submission and to allow you to make
                  updates. Your email will not be shared nor made public and we
                  will not use it for other purposes. See our
                  <a href="https://www.oecd.org/privacy/" target="_blank"
                    >privacy policy</a
                  >
                  for more information.</label
                >
                <div class="control mb-4">
                  <input
                    [ngClass]="{
                      'is-danger-bis':
                        showErrors && invalidInputs.includes('email')
                    }"
                    class="input is-large"
                    type="text"
                    formControlName="email"
                    id="email-input"
                    placeholder="your-email@organization.com"
                  />
                </div>
                <p
                  *ngIf="showErrors && invalidInputs.includes('email')"
                  class="has-text-danger-bis mt-0 is-size-7"
                >
                  A valid email is required.
                </p>
              </div>
            </div>
            <div class="column is-6 pt-5 pb-0">
              <h3 class="mt-0 mb-1 title is-6 is-sans is-uppercase is-bold">
                Your relation to this tool<span class="has-text-danger">*</span>
              </h3>
              <label class="is-size-7 help my-1"
                >Please specify your relation to the tool you're
                submitting</label
              >

              <div class="control mb-2 mt-4">
                <label
                  class="radio-input"
                  [ngClass]="{
                    'has-text-danger-bis':
                      showErrors && invalidInputs.includes('relationWithTool')
                  }"
                >
                  I work in or am affiliated to the organisation that created
                  the tool
                  <input
                    type="radio"
                    name="relationWithTool"
                    [value]="RelationWithTool.AffiliatedWithTool"
                    formControlName="relationWithTool"
                  />
                  <span class="checkmark"></span>
                </label>
              </div>
              <div class="control mb-2">
                <label
                  class="radio-input"
                  [ngClass]="{
                    'has-text-danger-bis':
                      showErrors && invalidInputs.includes('relationWithTool')
                  }"
                >
                  I do not work in nor am affiliated to the organisation that
                  created the tool but have substantial knowledge of the tool
                  (e.g. first-hand usage, research, etc.)
                  <input
                    type="radio"
                    name="relationWithTool"
                    [value]="RelationWithTool.ToolUser"
                    formControlName="relationWithTool"
                  />
                  <span class="checkmark"></span>
                </label>
              </div>
              <div class="control mb-2">
                <label
                  class="radio-input"
                  [ngClass]="{
                    'has-text-danger-bis':
                      showErrors && invalidInputs.includes('relationWithTool')
                  }"
                >
                  I have heard about the tool but have never used it
                  <input
                    type="radio"
                    name="relationWithTool"
                    [value]="RelationWithTool.HeardOfTool"
                    formControlName="relationWithTool"
                  />
                  <span class="checkmark"></span>
                </label>
              </div>
              <p
                *ngIf="showErrors && invalidInputs.includes('relationWithTool')"
                class="has-text-danger-bis mt-0 is-size-7"
              >
                <i class="fas fa-exclamation-triangle mr-2"></i> An answer is required.
              </p>
            </div>
          </div>

          <hr class="my-6" />
          <div class="field mb-5">
            <h3 class="mt-0 mb-1 title is-6 is-sans is-uppercase is-bold">
              Disclosures for contributors
            </h3>
            <div class="control mb-4 mt-1">
              <label
                class="checkbox-input mr-4"
                for="consent-publication-delay-input"
              >
                Once you submit tools, metrics, or use cases, we will review
                them and, if accepted, post them online. Please understand that
                due to the sheer volume of submissions, the process may take
                several days and communicating about the status of each
                submission may not be possible.
                <span class="has-text-danger">*</span>
                <input
                  type="checkbox"
                  formControlName="consentPublicationDelay"
                  id="consent-publication-delay-input"
                />
                <span class="checkmark"></span>
              </label>
            </div>
            <div class="control mb-4 mt-1">
              <label class="checkbox-input mr-4" for="consent-input">
                By checking this box, I certify that all information included in
                this Submission Form is true to the best of my knowledge and
                that OECD has the non-exclusive, sub-licensable right to
                publish, copy, reproduce, distribute, perform, translate, and
                make derivative works from the information and material
                provided. For more details, please see
                <a
                  href="https://www.oecd.org/termsandconditions/"
                  target="_blank"
                  >OECD's Terms and Conditions</a
                >
                and
                <a
                  href="https://oecd.ai/en/catalogue-disclosures"
                  target="_blank"
                  >Catalogue disclosures</a
                >. <span class="has-text-danger">*</span>
                <input
                  type="checkbox"
                  formControlName="consent"
                  id="consent-input"
                />
                <span class="checkmark"></span>
              </label>
            </div>
            <p
              *ngIf="showErrors && invalidInputs.includes('consent')"
              class="has-text-danger-bis mt-0 is-size-7"
            >
              Your consent is mandatory to submit the tool.
            </p>
          </div>

          <div class="has-text-center is-flex is-justify-content-center pt-5">
            <re-captcha
              formControlName="recaptchaReactive"
              required
              [siteKey]="captchaKey"
            ></re-captcha>
          </div>
          <div class="level">
            <div class="level-left">
              <p class="level-item is-size-7">
                After you click on 'Submit', the OECD Secretariat will review
                your submission.


              </p>
            </div>
            <div class="level-right">
              <div class="level-item">
                <button
                  class="button is-link"
                  [ngClass]="{
                    'is-loading': loadingSubmit
                  }"
                >
                  Submit tool
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
<app-image-gallery-modal
  (modalClosed)="
    onFieldChanged($event, 'defaultImage'); showImageGalleryModal = false
  "
  *ngIf="showImageGalleryModal"
></app-image-gallery-modal>
